import Carousel from '../modules/carousel'

$.fn.BlogCarousel = function() {
  let self = this

  return function() {
    let carousel = new Carousel(self.get(0), {
      slidesPerView: 1,
      loop: true,
      simulateTouch: false,
      spaceBetween: 20,
      pagination: {
        el: self.find('.blog-carousel__pagination').get(0),
        type: 'bullets',
        clickable: true,
      },
    }, {
      desktop: false,
    })
    carousel.init()
    return self
  }()
}
